// export const days = ["Κυ", "Δε", "Τρ", "Τε", "Πε", "Πα", "Σα"];
//
// export const months = [
//     "Ιανουάριος",
//     "Φεβρουάριος",
//     "Μάρτιος",
//     "Απρίλιος",
//     "Μάιος",
//     "Ιούνιος",
//     "Ιούλιος",
//     "Αύγουστος",
//     "Σεπτέμβριος",
//     "Οκτώβριος",
//     "Νοέμβριος",
//     "Δεκέμβριος",
// ];

export const days = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];
export const months = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "Jun",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
];